import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CoreSidebarService} from '../../../../@core/components/core-sidebar/core-sidebar.service';
import {AlertService} from '../../../shared/services/alert.service';
import {UserService} from '../../../shared/services/user.service';

@Component({
    selector: 'app-add-user',
    templateUrl: './add-user.component.html',
    styleUrls: ['./add-user.component.scss']
})
export class AddUserComponent implements OnChanges {
    addUserForm: FormGroup;
    inputTypePassword: any = 'password';
    submitted: any = false;
    submitting: any = false;
    @Output() valueSubmitted = new EventEmitter<any>();
    @Input() data: any;

    constructor(private _coreSidebarService: CoreSidebarService,
                private fb: FormBuilder,
                private alertService: AlertService,
                private userService: UserService) {
    }

    ngOnChanges(): void {
        this.refresh();
    }

    toggleSidebar(): void {
        this._coreSidebarService.getSidebarRegistry('add-user').toggleOpen();
    }

    refresh() {
        this.addUserForm = this.fb.group({
            'name': ['', Validators.required],
            'email': ['', Validators.compose([Validators.required, Validators.pattern('^(([^<>()[\\]\\\\.,;:\\s@\\"]+(\\.[^<>()[\\]\\\\.,;:\\s@\\"]+)*)|(\\".+\\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$')])],
            'contact': ['', Validators.compose([Validators.required, Validators.pattern('^[5-9]{1}[0-9]{9}$')])],
            'password': ['', (!this.data || !this.data['id']) ? Validators.required : '']
        });
        if (this.data && this.data['id']) {
            this.patchForm();
        }
    }

    patchForm() {
        this.addUserForm.patchValue({
            'name': (this.data && this.data['name']) ? this.data['name'] : '',
            'email': (this.data && this.data['email']) ? this.data['email'] : '',
            'contact': (this.data && this.data['contact']) ? this.data['contact'] : ''
        });
    }

    submit() {
        this.submitted = true;
        if (!this.addUserForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'name': (this.addUserForm.value && this.addUserForm.value.name) ? this.addUserForm.value.name : '',
                'email': (this.addUserForm.value && this.addUserForm.value.email) ? this.addUserForm.value.email : '',
                'contact': (this.addUserForm.value && this.addUserForm.value.contact) ? this.addUserForm.value.contact : '',
                'password': (this.addUserForm.value && this.addUserForm.value.password) ? this.addUserForm.value.password : ''
            };
            this.submitting = true;
            this.userService.create(params).subscribe(data => {
                if (data) {
                    this.submitting = false;
                    this.submitted = false;
                    this.valueSubmitted.emit(true);
                    this.addUserForm.reset();
                    this.addUserForm.patchValue({
                        'name': '',
                        'email': '',
                        'contact': '',
                        'password': ''
                    });
                }
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].name && error['error']['errors'].name.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].name[0]);
                        return;
                    }
                    if (error['error']['errors'].email && error['error']['errors'].email.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].email[0]);
                        return;
                    }
                    if (error['error']['errors'].contact && error['error']['errors'].contact.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].contact[0]);
                        return;
                    }
                }
            });
        }
    }

    update() {
        this.submitted = true;
        if (!this.addUserForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'name': (this.addUserForm.value && this.addUserForm.value.name) ? this.addUserForm.value.name : '',
                'email': (this.addUserForm.value && this.addUserForm.value.email) ? this.addUserForm.value.email : '',
                'contact': (this.addUserForm.value && this.addUserForm.value.contact) ? this.addUserForm.value.contact : ''
            };
            this.submitting = true;
            this.userService.update(this.data['id'], params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
                this.valueSubmitted.emit(true);
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].name && error['error']['errors'].name.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].name[0]);
                        return;
                    }
                    if (error['error']['errors'].email && error['error']['errors'].email.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].email[0]);
                        return;
                    }
                    if (error['error']['errors'].contact && error['error']['errors'].contact.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].contact[0]);
                        return;
                    }
                }
            });
        }
    }
}
